<!--  -->
<template>
  <div style="padding: 30px;">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="小程序素材" name="first">
        <wechattab />
      </el-tab-pane>
      <el-tab-pane label="小程序库" name="second">
        <library />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import wechattab from './components/wechattab.vue'
import library from './components/library.vue'
export default {
  components: { wechattab, library },
  data() {
    return {
      activeName: 'first'
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
